import React, { useEffect, useState } from 'react'
import { PublicClientApplication } from '@azure/msal-browser'
import Button from '@mui/material/Button'

// import { GoogleLogin, googleLogout } from "@react-oauth/google";
// import { Navigate } from 'react-router-dom'

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: '26b12ba1-58e4-43ef-9d1a-1dfe922bef73',
    authority: 'https://login.microsoftonline.com/common/oauth2/v2.0/',
    redirectUri: 'https://demo.lexai.nativeorange.ai/app/details'
  }
})

msalInstance.initialize()

const SSOLogin = props => {
  const { setMicrosoftUser } = props
  const [user, setUser] = useState(null)

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'))
    if (storedUser) setUser(storedUser)
  }, [])

  const loginWithMicrosoft = async () => {
    try {
      const response = await msalInstance.loginPopup({ scopes: ['User.Read'] })
      const userData = {
        name: response.account.name,
        email: response.account.username
      }
      setUser(userData)
      localStorage.setItem('user', JSON.stringify(userData))
      setMicrosoftUser({
        email: 'testuser',
        password: 'Python@123'
      })
    } catch (error) {
      console.error('Microsoft login error:', error)
    }
  }

  const logout = () => {
    localStorage.removeItem('user')
    setUser(null)
  }

  if (user) {
    return (
      <div className='container mt-5 text-center'>
        <h2>Profile</h2>
        <p>
          <strong>Name:</strong> {user.name}
        </p>
        <p>
          <strong>Email:</strong> {user.email}
        </p>
        <button className='btn btn-secondary' onClick={logout}>
          Logout
        </button>
      </div>
    )
  }

  return (
    <div className='container text-center mt-5'>
      <Button
        type='submit'
        variant='contained'
        onClick={loginWithMicrosoft}
        style={{ backgroundColor: '#FF4D00', color: '#fff' }}
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='16'
          height='16'
          fill='currentColor'
          className='bi bi-microsoft'
          viewBox='0 0 16 16'
        >
          <path d='M7.462 0H0v7.19h7.462V0zM16 0H8.538v7.19H16V0zM7.462 8.211H0V16h7.462V8.211zm8.538 0H8.538V16H16V8.211z' />
        </svg>{' '}
        &nbsp; &nbsp; Login with Microsoft
      </Button>
    </div>
  )
}

export default SSOLogin
